import { SERVICE_CODES } from '@/lib/consts';

import { DocumentTypeCode } from '@/api/types';

export const SERVICE_CODE = SERVICE_CODES.REAPPLICATION;
export const STEP_NUMBER_TO_PAY = 7;
export const STEP_NUMBER_TO_SIGN_UP = 6;
export const ALLOWED_ADDITIONAL_DOC_TYPES = [
  DocumentTypeCode.EXTRACT_ERDR,
  DocumentTypeCode.LEGAL_RESIDENCE,
  DocumentTypeCode.RESOLUTION,
  DocumentTypeCode.LEASE_AGREEMENT,
  DocumentTypeCode.INSURANCE_POLICY,
  DocumentTypeCode.EXRACT_PRPR,
  DocumentTypeCode.PERMIT,
  DocumentTypeCode.POWER_OF_ATTORNEY,
  DocumentTypeCode.INVITE_UKR,
  DocumentTypeCode.OWNERSHIP_CERTIFICATE,
  DocumentTypeCode.CERT_MARRIAGE,
  DocumentTypeCode.EXPERT_RESEARCH,
  DocumentTypeCode.CONTRACT_SECURITY_ACTIVITIES,
  DocumentTypeCode.WORK_REFERENCE,
  DocumentTypeCode.CERTIFICATION,
  DocumentTypeCode.CERT_IDP,
  DocumentTypeCode.APPLICATION,
  DocumentTypeCode.PAYMENT_REFERENCE,
  DocumentTypeCode.MEDICAL_REFERENCE,
  DocumentTypeCode.LEARNING_DOCUMENT,
  DocumentTypeCode.OTHER,
];
export const MAX_DOCUMENTS_NUMBER = 10;
